module.exports = require("electron-store");